import { AccordionDetailsProps as MuiAccordionDetailsProps } from '@mui/material/AccordionDetails'

export type AccordionDetailsProps = MuiAccordionDetailsProps
